import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { ThemeContext } from "../../context/ThemeProvider";
import Body from "../../ui/Body";
import Linkskupage from "./Linkskupage";

// import Kaorder from "./khiladiadda/KaOrder"
import Qacoupon from "./QaCoupon";

export default function Linksku() {

  // theme context


  let navigate = useNavigate();


  return (
    <>
      {/* navigation section */}
      <section>
        <Sidebar />
        <Nabvar />
      </section>

      {/* body */}
      <Body>
      <Linkskupage/>
      </Body>
    </>
  );
}
